var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-tooltip"},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }